import AppLayout from './app-layout'
import AuthorisedLayout from './authorised-layout'
import {RegHolderName, Reducer} from './authorised-layout/current-reg-holder'


export {
  AppLayout,
  AuthorisedLayout,
  RegHolderName,
  Reducer
}



// WEBPACK FOOTER //
// ./src/layout/index.js